import React from 'react';
import './Header.scss';

export default function Header({ text }: { text?: string }) {
    return (
        <header className="header">
            <div className="header__content">{text && <h1>{text}</h1>}</div>
        </header>
    );
}
